export default __webpack_public_path__ + "static/media/dj.5216627a.svg";